module.exports = __webpack_public_path__ + "static/media/vector3.86dfd50e.png";